import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const ComprehensiveAssessmentManagementStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .comprehensive-assessment-management {
    display: flex;
    flex-direction: column;
    height: 100%;

    .content-footer {
      margin-top: auto !important;
    }
  }

  .background-white {
    background-color: white;
    box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.12) !important;
    border: 0 !important;
    color: ${VARIABLES.COLORS.GRAY_3};
    white-space: pre-line;
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};

    &.place-bottom {
      border-bottom-color: white;

      &:after,
      &:before {
        display: none;
      }
    }
  }

  .business-type {
    display: flex;
  }

  .content-body {
    height: 100%;
  }

  .react-tabs__tab-panel {
    .page-button {
      justify-content: flex-end;
    }
  }

  .react-tabs__tab-panel--selected {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  /* GRADE WRAPPER */
  .grade-wrapper {
    background-color: #f7f7f7;
    padding: 16px;
    border-radius: 5px;
  }

  .grade-header {
    border-bottom: 1px dashed #aaaaaa;

    .select__control {
      background-color: white;
      height: 32px;
      margin-left: 1rem;
      min-height: 32px;
      font-size: 14px;
    }

    .select__dropdown-indicator {
      padding: 2px 8px 0 8px;
    }
  }

  .grade-body {
    padding: 0 50px;
  }
  .grade-name-wrap {
    width: 300px;
    padding: 0 20px 20px 0;
    text-align: right;
  }
  .grade,
  .grade-name,
  .separator {
    color: ${VARIABLES.COLORS.BLUE_1};
  }
  .separator {
    margin: 0 20px 0 20px;
  }
  .form-group-control {
    &.is-error {
      .input-control {
        .input {
          border-color: ${VARIABLES.COLORS.RED_1};
        }
      }
    }
  }
  .form-group-grade {
    flex: 0 0 70%;
    flex-wrap: wrap;
    .form-group-wrapper {
      flex: 1 1 auto;
      align-items: center;
    }
    &.is-error {
      label {
        color: ${VARIABLES.COLORS.RED_1};
      }

      .input-control {
        .input {
          border-color: ${VARIABLES.COLORS.RED_1};
        }
      }

      .message {
        opacity: 1;
      }
    }
    .message {
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.TN};
      color: ${VARIABLES.COLORS.RED_1};
      opacity: 0;
      flex-wrap: wrap;
    }
  }
  .grade-row {
    /* gap: 10px 30px; */
    display: flex;
    align-items: center;
    .input {
      text-align: center;
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
